import {Injectable} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../../environments/environment';

@Injectable()
export class AccountService {
  constructor(private http: HttpClient) {
  }

  get(): Observable<HttpResponse<Account>> {
    return this.http.get<Account>(environment.apiUrl + 'user/me', {observe: 'response'});
  }

  save(account: any): Observable<HttpResponse<any>> {
    return this.http.post(environment.apiUrl + 'user/me', account, {observe: 'response'});
  }

  editPwd(idUser: number, password: string): Observable<any> {
    return this.http.post<any>(environment.apiUrl + 'user/change_password/' + idUser, {password: password});
  }

  acceptPrivacy(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'user/accept_privacy');
  }

  searchAccess(): Observable<any[]> {
    return this.http.get<any[]>(environment.apiUrl + 'user/access_list');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/account.service.ts